(ns frontend.ui.component.lp-portal.report.body.private-equity.fund.credit-v2.controller
  (:require
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.controller :as pe-controller]))

(defn ->ui-data
  [{:keys [report-data] :as props}]
  {:fund-name (:fund-name report-data)
   :reference-date (get-in report-data [:reference-date])
   :tearsheet (pe-controller/tearsheet-ui-data (update props :dynamic-path concat [:tearsheet]))
   :overview (pe-controller/overview-ui-data (update props :dynamic-path concat [:overview]))
   :details-and-figures (pe-controller/details-and-figures-ui-data
                         (update props :dynamic-path concat [:details-and-figures]))
   :esg (pe-controller/esg-ui-data (update props :dynamic-path concat [:esg]))
   :investors (pe-controller/investors-ui-data (update props :dynamic-path concat [:investors]))
   :capital-account-since-inception (report-ctl/with-footnote
                                     props
                                     :capital-account-since-inception-footnotes
                                     (get-in report-data [:capital-account-since-inception]))
   :capital-account-year-to-date (report-ctl/with-footnote
                                  props
                                  :capital-account-year-to-date-footnotes
                                  (get-in report-data [:capital-account-year-to-date]))
   :fees-and-carried-interest (report-ctl/with-footnote
                               props
                               :fees-and-carried-interest-footnotes
                               (get-in report-data
                                       [:fees-and-carried-interest]))})

(defn ->ui-data-v3
  [props]
  (assoc (->ui-data props)
         :market-outlook (report-ctl/rich-content props :market-outlook)
         :market-outlook-2 (report-ctl/rich-content props :market-outlook-2)))
